module.exports = __webpack_public_path__ + "static/media/banner_720.aa3668f8.jpg";